import React, { useContext, useEffect, useState } from 'react'
import "../../assets/styles/Navbar.css"
import Logo from "../../assets/images/main-logo.png"
import { Link, NavLink, useLocation } from 'react-router-dom';
import { axiosInstance, config } from '../pages/config';
import secureLocalStorage from 'react-secure-storage';
import { ServicesContext } from '../Reusable/ServiceContextmain';

const Navbar = () => {
    const [stickyheader, setStickyHeader] = useState(false);
    const [sideMenu, setSideMenu] = useState(false);
    const [activemenu , setActiveMenu] = useState(false);

    window.addEventListener("scroll", () => {
        if (window.scrollY > 100) {
            setStickyHeader(true);
        } else {
            setStickyHeader(false);
        }
    });
    const location = useLocation(); 

    const { services, loading, error } = useContext(ServicesContext);
    const [Loading, setLoading] = useState(false);

    return (
        <div className={sideMenu ? "nav-expanded" : ""}>
            <div className="offwrap"></div>
            <div className="full-width-header">
                <header id="rs-header" className="rs-header">
                    <div className="middle-header hidden-md">
                        <div className="container">
                            <div className="row-table">
                                <div className="col-cell header-logo">
                                    <div className="logo-part">
                                        <NavLink to={`${config.appUrl}`} >
                                            <img src={Logo} alt="" width="192" height="40" />
                                        </NavLink>
                                    </div>
                                </div>
                                <div className="col-cell">
                                    <div className="rs-contact-info">
                                        <div className="contact-part">
                                            <div className="info-icon">
                                                <i className="bi bi-telephone-inbound"></i>
                                            </div>
                                            <div className="contact-info">
                                                <div className="info-title">
                                                    Call Us
                                                </div>
                                                <div className="info-des">
                                                    <a href="tel:01162102688">0116 210 2688</a> / <a href="tel:07380851496">07380851496</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="contact-part">
                                            <div className="info-icon">
                                                <i className="bi bi-envelope-open"></i>
                                            </div>
                                            <div className="contact-info">
                                                <div className="info-title">
                                                    Email us
                                                </div>
                                                <div className="info-des">
                                                    <a href="mailto:info@precisioncontractservices.com">
                                                        info@precisioncontractservices.com
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="contact-part margin-no">
                                            <div className="info-icon" style={{ visibility: 'hidden' }}>
                                                <i className="bi bi-facebook"></i>
                                            </div>
                                            <div className="contact-info">
                                                <div className="info-title">
                                                    Follow Us
                                                </div>
                                                <div className="info-des">
                                                    <a href="https://www.facebook.com/PrecisionContractCleaningServices" target="_blank" rel="noopener noreferrer">
                                                        <i className="bi bi-facebook"></i>
                                                    </a>
                                                    <a href="https://www.instagram.com/precisioncontractcleaning/" target="_blank" rel="noopener noreferrer" style={{ marginLeft: '10px' }}>
                                                        <i className="bi bi-instagram"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`menu-area menu-sticky ${stickyheader ? 'sticky' : ""}`}>
                        <div className="container">
                            <div className="row-table">
                                <div className="col-cell header-logo">
                                    <div className="logo-area">
                                        <NavLink to={`${config.appUrl}`} >
                                            <img className="sticky-logo" src={Logo} alt="logo" width="192" height="40" />
                                        </NavLink>
                                    </div>
                                </div>
                                <div className="col-cell">
                                    <div className="rs-menu-area">
                                        <div className="main-menu">
                                            <nav className="rs-menu hidden-md">
                                                <ul className="nav-menu">
                                                    <li className="menu-item-has-children">
                                                        <Link to={`${config.appUrl}`} >Home</Link>
                                                    </li>
                                                    <li className="menu-item-has-children">
                                                        <NavLink to={`${config.appUrl}about-us`} >About Us</NavLink>
                                                    </li>
                                                    <li className="menu-item-has-children">
                                                        <NavLink to={`${config.appUrl}services`} >Our Services <i class="bi bi-chevron-down"></i></NavLink>
                                                        <ul class="sub-menu pt-3">
                                                            {services?.map((item) => (
                                                                <li>
                                                                    <Link to={`${config.appUrl}service/${item?.slug}`}>{item?.name}</Link>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </li>
                                                    <li className="menu-item-has-children">
                                                        <NavLink to={`${config.appUrl}case-studies`} >Case Studies</NavLink>
                                                    </li>
                                                    <li className="menu-item-has-children">
                                                        <NavLink to={`${config.appUrl}news-and-update`}>News & Update</NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to={`${config.appUrl}contact-us`} >Contact Us</NavLink>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-cell">
                                    <div className="expand-btn-inner">
                                        <ul style={{listStyle : "none"}} className='mb-0'>
                                            <li className="sidebarmenu-search">
                                            </li>
                                            <li className="nav-link">
                                                <a id="nav-expander" className="nav-expander bar" onClick={() => setSideMenu(true)}>
                                                    <span className="dot-hum"></span>
                                                    <span className="dot-hum"></span>
                                                    <span className="dot-hum"></span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <nav className="right_menu_togle menu-wrap-off  hidden-md">
                        <div className="close-btn">
                            <a id="nav-close" className="nav-close" onClick={() => setSideMenu(false)}>
                                <div className="line">
                                    <span className="line1"></span>
                                    <span className="line2"></span>
                                </div>
                            </a>
                        </div>
                        <div className="rs-offcanvas-inner">
                            <div className="canvas-logo">
                                <a href="#"><img src={Logo} alt="logo" width="192" height="40" /></a>
                            </div>
                            <div className="offcanvas-text">
                                <p>Home cleaning service options and continue to lead by example, leaving other cleaning companies.</p>
                            </div>
                            <div className="canvas-contact">
                                <div className="address-area">
                                    <div className="address-list">
                                        <div className="info-icon">
                                            <i className="bi bi-geo-alt"></i>
                                        </div>
                                        <div className="info-content">
                                            <h4 className="title">Address</h4>
                                            <em>4 Rivers Street, Leicester, England, LE3 5RX</em>
                                        </div>
                                    </div>
                                    <div className="address-list">
                                        <div className="info-icon">
                                            <i className="bi bi-envelope"></i>
                                        </div>
                                        <div className="info-content">
                                            <h4 className="title">Email Us</h4>
                                            <em><a href="mailto:info@precisioncontractservices.com">info@precisioncontractservices.com</a></em>
                                        </div>
                                    </div>
                                    <div className="address-list">
                                        <div className="info-icon">
                                            <i className="bi bi-telephone"></i>
                                        </div>
                                        <div className="info-content">
                                            <h4 className="title">Get Free Estimate</h4>
                                            <a href='callto:0116 2102 688'><em>0116 2102 688</em></a>
                                        </div>
                                    </div>
                                </div>
                                {/* <ul className="social">
                                    <li>
                                        <a className='' target='_blank' href='https://www.facebook.com/login/'><i className='bi bi-facebook d-block'></i></a>
                                    </li>
                                    <li>
                                        <a target='_blank' href='https://www.instagram.com/accounts/login/'><i className='bi bi-instagram d-block'></i></a>
                                    </li>
                                    <li>
                                        <a href='https://x.com/login' target='_blank'><i className='bi bi-twitter-x d-block'></i></a>
                                    </li>
                                    <li>
                                        <a href='https://www.linkedin.com/login' target='_blank'><i className='bi bi-linkedin d-block'></i></a>
                                    </li>
                                </ul> */}
                            </div>
                        </div>
                    </nav>
                    <nav className="right_menu_togle mobile-navbar-menu" id="mobile-navbar-menu">
                        <div className="close-btn hash-has-sub">
                            <a id="nav-close2" className="nav-close hash" onClick={() => setSideMenu(false)}>
                                <div className="line">
                                    <span className="line1"></span>
                                    <span className="line2"></span>
                                </div>
                            </a>
                        </div>
                        <ul className="nav-menu" style={{listStyle:"none"}}>
                            <li className="menu-item-has-children current-menu-item has-sub hash-has-sub">
                                <Link to={`${config.appUrl}`} className={location.pathname === config.appUrl ? "active" : ""} onClick={() => setSideMenu(false)} >Home</Link>
                                {/* <ul class="sub-menu">
                                    <li><a href="about.html">About</a></li>
                                    <li><a href="faqs.html">Faqs</a></li>
                                    <li><a href="request-an-estimate.html">Reguest An Estimate</a></li>
                                </ul> */}
                            </li>
                            <li className="menu-item-has-children has-sub hash-has-sub">
                                <Link to={`${config.appUrl}about-us`} className={location.pathname === `${config.appUrl}about-us` ? "active" : ""}
                                    onClick={() => setSideMenu(false)}>About Us</Link>
                            </li>
                            <li className="menu-item-has-children new">
                                <Link className="hash d-flex justify-content-between" href
                                   onClick={() => {
                                    setActiveMenu(!activemenu);
                                    }}
                                    >Our Services <i class={`${activemenu ? 'bi bi-chevron-up' : 'bi bi-chevron-down'}`}></i></Link>
                                {activemenu && (
                                <ul class="Submenu">
                                    {services?.map((item) => (
                                        <li>
                                            <Link to={`${config.appUrl}service/${item?.slug}`} onClick={() => setSideMenu(false)}>{item?.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                                )}
                            </li>
                            <li className="menu-item-has-children has-sub hash-has-sub">
                                <Link to={`${config.appUrl}case-studies`} className={location.pathname === `${config.appUrl}case-studies` ? "active" : ""}
                                    onClick={() => setSideMenu(false)}>Case Studies</Link>
                            </li>
                            <li className="menu-item-has-children has-sub hash-has-sub">
                                <Link to={`${config.appUrl}news-and-update`} 
                                    className={location.pathname === `${config.appUrl}news-and-update` ? "active" : ""}
                                    onClick={() => setSideMenu(false)}>News & Update</Link>
                            </li>
                            <li className="hash-has-sub">
                                <Link to={`${config.appUrl}contact-us`} 
                                    className={location.pathname === `${config.appUrl}contact-us` ? "active" : ""}
                                onClick={() => setSideMenu(false)} >Contact Us</Link>
                            </li>
                        </ul>
                        <div className="canvas-contact mt-5">
                            <div className="address-area">
                                <div className="address-list">
                                    <div className="info-icon">
                                        <i className="flaticon-location"></i>
                                    </div>
                                    <div className="info-content">
                                        <h4 className="title">Address</h4>
                                        <em>4 Rivers Street, Leicester, England,LE3 5RX</em>
                                    </div>
                                </div>
                                <div className="address-list">
                                    <div className="info-icon">
                                        <i className="flaticon-email"></i>
                                    </div>
                                    <div className="info-content">
                                        <h4 className="title">Email</h4>
                                        <em className="hash-has-sub"><a href="mailto:info@precisioncontractservices.com" className="hash">info@precisioncontractservices.com</a></em>
                                    </div>
                                </div>
                                <div className="address-list">
                                    <div className="info-icon">
                                        <i className="flaticon-call"></i>
                                    </div>
                                    <div className="info-content">
                                        <h4 className="title">Phone</h4>
                                        <a href='callto:0116 2102 688'><em>0116 2102 688</em></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </header>
            </div>
        </div>
    )
}

export default Navbar
